import { IMenuClientDataElement } from "web/types/MenuClient";

import {
  ICustomerMenuSection,
  ICustomerMenuSectionItem,
} from "web/features/customerMenu/customerMenuSlice";

const LEGACY_NAME_MAPPING: Record<string, string> = {
  Pomoc: "Centrum pomocy",
};

const getItemsWithRestrictions = (
  section: ICustomerMenuSection,
  payload: IMenuClientDataElement[],
  payloadElementNumber: 0 | 1 | 2
): ICustomerMenuSectionItem[] => {
  return section.items.reduce<ICustomerMenuSectionItem[]>((acc, item) => {
    const mappedItemName = LEGACY_NAME_MAPPING[item.name] || item.name;

    const currentPayloadElement = payload[payloadElementNumber].items.find(
      (payloadElement) =>
        payloadElement.original_name === mappedItemName ||
        LEGACY_NAME_MAPPING[payloadElement.original_name] === mappedItemName
    );

    if (currentPayloadElement && +currentPayloadElement.status === 1) {
      return [
        ...acc,
        {
          name: currentPayloadElement.original_name,
          title: currentPayloadElement.name,
          url: item.url,
          position: item.position,
        },
      ];
    }

    return acc;
  }, []);
};

export default getItemsWithRestrictions;
